/**
 * AudiRS5 — Generated by hearth-asset-pipeline
 * Furniture: 3×2 tiles
 * Generated: 2026-04-11T05:57:57.601Z
 *
 * This is a procedural isometric furniture renderer produced from a 3D model.
 * Integrates with Hearth's renderFurniture() dispatch and isoBox primitives.
 */

import { renderIsoAsset, type IsoAssetDef } from "../../render/iso-engine.js";

/** Furniture registry metadata */
export const AudiRS5_META = {
  id: "AudiRS5",
  name: "AudiRS5",
  tileWidth: 3,
  tileHeight: 2,
  isoWidth: 74,
  isoDepth: 63,
  canonicalRot: 0 as const,
  interactionAnchors: [
    { type: "use_point", localWx: 1, localWy: 0, elevation: 0, faceDir: "S" },
  ],
} as const;

/** Declarative asset definition — pure data, no rendering code */
export const AudiRS5_DEF: IsoAssetDef = {
  id: "AudiRS5",
  name: "AudiRS5",
  tile: [3, 2],
  geometry: { w: 42, d: 96, h: 24 },
  faces: {
    top: {
      base: "#0c0c0c",
      palette: ["#0c0c0c", "#e9e9e9", "#1c1c1c", "#131313", "#3b3b3b"],
      metalness: 0.65,
      roughness: 0.63,
      opacity: 1.00,
      materialType: "metal",
      gradient: { stops: [[0.00, "#828282"], [0.33, "#676767"], [0.67, "#4f4f4f"], [1.00, "#5a5555"]], strength: 0.401 },
      grain: { scale: 2.0, contrast: 0.300, angle: 90 },
      specular: { x: 0.57, y: 0.50, radius: 0.60, intensity: 0.80 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    left: {
      base: "#030303",
      palette: ["#030303", "#0b0b0b", "#131212", "#d4d4d4", "#3b3b3b"],
      metalness: 0.65,
      roughness: 0.64,
      opacity: 1.00,
      materialType: "metal",
      gradient: { stops: [[0.00, "#393636"], [0.33, "#1e1e1e"], [0.67, "#1b1b1b"], [1.00, "#6e6e6e"]], strength: 0.816 },
      grain: { scale: 2.0, contrast: 0.300, angle: 90 },
      specular: { x: 0.53, y: 0.38, radius: 0.60, intensity: 0.80 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
    right: {
      base: "#030303",
      palette: ["#030303", "#5e5e5e", "#0e0e0e", "#bababa", "#333333"],
      metalness: 0.65,
      roughness: 0.65,
      opacity: 1.00,
      materialType: "metal",
      gradient: { stops: [[0.00, "#323232"], [0.33, "#070707"], [0.67, "#343434"], [1.00, "#8b8b8b"]], strength: 0.833 },
      specular: { x: 0.52, y: 0.47, radius: 0.60, intensity: 0.80 },
      edgeDarken: 0.20,
      edgeHighlight: 0.40,
    },
  },
  anchors: [
    { type: "use_point", wx: 1, wy: 0, elevation: 0, dir: "S" },
  ],
};

/**
 * Render AudiRS5 via the shared isometric material engine.
 * Drop-in compatible with Hearth's renderFurniture() dispatch.
 */
export function renderAudiRS5(
  ctx: CanvasRenderingContext2D,
  screenX: number,
  screenY: number,
  direction: 0 | 1 | 2 | 3,
  state: Record<string, unknown>,
  time: number,
): void {
  renderIsoAsset(ctx, AudiRS5_DEF, screenX, screenY, direction, state, time);
}